import { createQueryKeys } from '@lukemorales/query-key-factory';
import { ContentService } from '../services';
export const contentQueries = createQueryKeys('content', {
    byId: (pageId) => ({
        queryKey: [pageId],
        queryFn: () => ContentService.getContent(pageId)
    })
});
